<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
        :additionalSaveFunction="formatAmountBeforeSave"
        :useAdditionalSaveFunction="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_COST_GROUP')" 
                        :items="costGroupItems" 
                        :context="context"
                        field="CostGroup"
                        :alvqa="alvqa + '-dropdown-cost-group'"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Description"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DESCRIPTION')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-description'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="DocumentNumber"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DOCUMENT_NUMBER')"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-document-number'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Recipient"
                        :label="$t('lang_GENERIC_CAPTION_RECIPIENT')"
                        rules="required"
                        :withFreeText="false"
                        :withMargin="false"
                        :alvqa="alvqa + '-autocomplete-recipient-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-recipient-selection'">
                                {{ getPersonInfo(item) }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span>
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-recipient-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-recipient-dropdown-' + items.alvId + '-title'">
                                    {{ getPersonInfo(items) }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-recipient-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :label="$t('lang_GENERAL_CAPTION_COUNTRY')" 
                        :items="countryItems" 
                        :context="context"
                        field="Country"
                        rules="required"
                        :alvqa="alvqa + '-dropdown-country'"
                        :withMargin="false"
                        :clearable="false"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="Date"
                        :label="$t('lang_GENERIC_CAPTION_DATE')"
                        rules="required"
                        :withMargin="false"
                        :alvqa="alvqa + '-datepicker-date'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="PaidOn"
                        :withMargin="false"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_PAID_ON')"  
                        :alvqa="alvqa + '-datepicker-paid-on'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Amount"
                        :label="$t('lang_GENERIC_CAPTION_AMOUNT')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-amount'"
                        :suffix="$store.getters.getSelectedCurrency"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import { DropdownGenericCostGroupTypes } from '@/assets/dropdowns/alvDropdowns.js' 

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'

export default {
    name: "ReleasesCostsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageDropdown,
        BaseEditPageDatePicker,
        BaseEditPageTextField,
        BaseEditPageAutocomplete
    },
    data() {
        return {
            context: 'ReleasesCosts',
            alvqa: "label-releases-edit-form-panel-costs-editing-dialog"
        }
    },
    computed: {
        costGroupItems() { return DropdownGenericCostGroupTypes },
        countryItems() { return this.$alvPlugin.getListOfTranslatedCountries() }
    },
    methods: {
        formatAmountBeforeSave(item) {
            item.amount = this.$alvPlugin.stringToFloat(item.amount)
            return item
        },
        getPersonInfo(item){
            if(item.inheritFromGroup === true && item.inheritFromGroupObject !== null){
                return item.inheritFromGroupObject.inv_company_name
            }else{

                if(item.group !== null && item.group !== '' &&  item.group !== undefined){
                    return item.group
                }else{
                    return item.gemaName
                }
            }
        }
    },
    mounted() {
        this.$store.commit('setCountries')
    }
}
</script>